/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { classStyleHelper } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// GRID : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	grid: {
		extend: [classStyleHelper.direction],

		// ----- direction ----- //
		'& .gridset': {
			'&.direction-horizontal': {
				flexDirection: 'row'
			},
			'&.direction-vertical': {
				flexDirection: 'column',
				'& .griditem': {
					marginRight: '0 !important'
				}
			}
		}
	}
});